import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import UsersService from "../../api/users";


export const getUsers = createAsyncThunk(
  "users/get",
  async (args, thunkAPI) => {
    try {
      const response = await UsersService.getUsers(args);
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data ) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getUserDetail = createAsyncThunk(
  "userDetail/get",
  async (id, thunkAPI) => {
    try {
      const response = await UsersService.getUserDetail(id);
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data ) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const updateUser = createAsyncThunk(
  "userDetail/patch",
  async ({id, args}, thunkAPI) => {
    try {
      const response = await UsersService.updateUser(id, args);
      //thunkAPI.dispatch(setMessage(response.data.message));
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data) ||
        error.message ||
        error.toString();
      //thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const createUser = createAsyncThunk(
  "userDetail/post",
  async (args, thunkAPI) => {
    try {
      const response = await UsersService.createUser(args);
      //thunkAPI.dispatch(setMessage(response.data.message));
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data ) ||
        error.message ||
        error.toString();
      //thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const deleteUser = createAsyncThunk(
  "user/delete",
  async (args, thunkAPI) => {
    try {
      const response = await UsersService.deleteUser(args);
      //thunkAPI.dispatch(setMessage(response.data.message));
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data ) ||
        error.message ||
        error.toString();
      //thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  }
);

const initialState = {
  results: [],
  count: 0,
  next: null,
  previous: null,
  selectedUser: null,
  events: [],
  error: null,
  loadingUpdate: false,
};

const usersSlice = createSlice({
  name: "users",
  initialState,
  extraReducers: {
    [getUsers.fulfilled]: (state, action) => {
      Object.assign(state, action.payload);
    },
    [getUsers.rejected]: (state, action) => {
      state.error = "Ekki tókst að sækja notendur";
    },
    [getUserDetail.fulfilled]: (state, action) => {
      state.selectedUser = action.payload;
    },
    [getUserDetail.rejected]: (state, action) => {
      state.error = "Ekki tókst að sækja notanda";
    },
    [updateUser.pending]: (state, action) => {
      state.loadingUpdate = true;
    },
    [updateUser.fulfilled]: (state, action) => {
      state.selectedUser = Object.assign(state.selectedUser, action.payload);
      state.loadingUpdate = false;
    },
    [updateUser.rejected]: (state, action) => {
      state.error = "Ekki tókst að uppfæra notanda";
      state.loadingUpdate = false;
    },
    [createUser.pending]: (state, action) => {
      state.loadingUpdate = true;
    },
    [createUser.fulfilled]: (state, action) => {
      state.selectedUser = action.payload
      state.loadingUpdate = false;
    },
    [createUser.rejected]: (state, action) => {
      state.error = "Ekki tókst að uppfæra notanda";
      state.loadingUpdate = false;
    },
  },
});

const { reducer } = usersSlice;
export default reducer;